import { render, staticRenderFns } from "./CateringStatisticTable.vue?vue&type=template&id=479d504d&"
import script from "./CateringStatisticTable.vue?vue&type=script&lang=js&"
export * from "./CateringStatisticTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports